export default {
  OPEN: 'Open',
  COMPLETE: 'Complete'
};
